/**
 * Professional Parallax Animation Worklet
 * 
 * Provides ultra-smooth, high-performance scroll-linked 3D depth effects.
 * By running in the AnimationWorklet, this avoids main-thread jank.
 */

class ParallaxAnimator {
  animate(currentTime: number, effect: any) {
    // Scroll progress is typically passed as the current time of the timeline
    // We map this progress to a 3D translation
    const scrollProgress = currentTime; 
    
    // Configurable depth factor
    const depth = 0.5; 
    
    // Apply transform via the effect's local time which maps to the animation property
    effect.localTime = scrollProgress * depth;
  }
}

registerAnimator('fluent-parallax', ParallaxAnimator);
